import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  CreateIssuePayload,
  IssueDto,
  IssueLocationListResponseDto,
  IssueRoleListResponseDto,
  IssueAttachmentDto,
  UpdateIssuePayload,
  UpdateIssueStatusPayload,
} from '../models/issue.models';

@Injectable({ providedIn: 'root' })
export class IssuesApi {
  private readonly http = inject(HttpClient);
  private readonly issuesBaseUrl = '/api/bhp/api/issues';
  private readonly locationsBaseUrl = '/api/bhp/api/locations';
  private readonly rolesBaseUrl = '/api/auth/api/roles';

  getLocations(): Observable<IssueLocationListResponseDto> {
    return this.http.get<IssueLocationListResponseDto>(`${this.locationsBaseUrl}/`);
  }

  getRoles(): Observable<IssueRoleListResponseDto> {
    return this.http.get<IssueRoleListResponseDto>(`${this.rolesBaseUrl}/`);
  }

  getIssues(): Observable<IssueDto[]> {
    return this.http.get<IssueDto[]>(`${this.issuesBaseUrl}/`);
  }

  createIssue(payload: CreateIssuePayload): Observable<IssueDto> {
    const formData = new FormData();
    formData.append('title', payload.title);
    formData.append('description', payload.description);
    formData.append('priority', payload.priority);
    formData.append('due_date', payload.dueDate);
    formData.append('location_id', payload.locationId);
    formData.append('assigned_role_id', String(payload.assignedRoleId));
    payload.attachments.forEach((attachment) => {
      formData.append('attachments', attachment, attachment.name);
    });

    return this.http.post<IssueDto>(`${this.issuesBaseUrl}/adhoc/`, formData);
  }

  updateIssue(issueId: string, payload: UpdateIssuePayload): Observable<IssueDto> {
    return this.http.patch<IssueDto>(`${this.issuesBaseUrl}/${issueId}/`, {
      title: payload.title,
      description: payload.description,
      priority: payload.priority,
      due_date: payload.dueDate,
      location_id: payload.locationId,
      assigned_role_id: payload.assignedRoleId,
    });
  }

  addIssueAttachment(issueId: string, attachment: File): Observable<IssueAttachmentDto> {
    const formData = new FormData();
    formData.append('file', attachment, attachment.name);
    return this.http.post<IssueAttachmentDto>(
      `${this.issuesBaseUrl}/${issueId}/attachments/`,
      formData,
    );
  }

  deleteIssueAttachment(issueId: string, attachmentId: string): Observable<void> {
    return this.http.delete<void>(`${this.issuesBaseUrl}/${issueId}/attachments/${attachmentId}/`);
  }

  updateIssueStatus(issueId: string, payload: UpdateIssueStatusPayload): Observable<IssueDto> {
    return this.http.patch<IssueDto>(`${this.issuesBaseUrl}/${issueId}/status/`, payload);
  }
}
